import {
    VehicleAttachment,
    VehicleParameter,
} from "../../../../types/types";

export const createInitialVehicleParameter = (
    vehicleId: number,
    customerId: number,
): VehicleParameter => ({
    id: null,
    vehicleId,
    customerId,
    currentOdometer: null,
    fuelTankCapacity: null,
    observation: null,
    useAlert: false,
    maintenanceAlertDays: null,
    maintenanceAlertKm: null,
    oilChangeAlertDays: null,
    oilChangeAlertKm: null,
    activated: true,
    files: [],
    removedFiles: [],
});

export const normalizeVehicleParameterResponse = (
    response: VehicleParameter,
    vehicleId: number,
    customerId: number,
): VehicleParameter => ({
    ...createInitialVehicleParameter(vehicleId, customerId),
    ...response,
    vehicleId,
    customerId,
    files: Array.isArray(response.files) ? response.files : [],
    removedFiles: [],
});

export const buildVehicleParameterPayload = ({
    vehicleParameter,
    vehicleId,
    customerId,
    newFiles,
    removedFiles,
}: {
    vehicleParameter: VehicleParameter;
    vehicleId: number;
    customerId: number;
    newFiles: VehicleAttachment[];
    removedFiles: number[];
}): VehicleParameter => ({
    ...vehicleParameter,
    vehicleId,
    customerId,
    observation: vehicleParameter.observation?.trim() || null,
    files: newFiles.map((file) => ({
        file: file.file,
        description: file.description?.trim() || null,
        name: file.name,
        type: file.type,
    })),
    removedFiles,
});
